import bus from "./bus.mp3";

const sounds = {
bus
}
export default sounds;
